import React, { useState, useEffect, useRef } from "react";
import { AsyncTypeahead, Highlighter } from "react-bootstrap-typeahead";

import 'react-bootstrap-typeahead/css/Typeahead.css';

import axios from '../../../axios-graphql-client';
import usePrevious from "../../../hooks/usePrevious";

import classes from './CustomAsyncTypehead.module.css';

import { selectOptions } from "../../../shared/utility";

import EllipsisWithTooltip from 'react-ellipsis-with-tooltip';

const CustomAsyncTypehead: React.FC<any> = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [query, setQuery] = useState(null);

  const {
    postData,
    postUrl,
    autoCompleteName,
    includeSynonymsFieldValue,
    autoCompleteReturnString,
    selectFieldValue,
    setFieldValue,
    name,
    multiple,
    selected
  } = props;

  const selectedRef = React.useRef([]);
  selectedRef.current = selected;

  const typeaheadRef = useRef();

  const prevSelectFieldValue = usePrevious(selectFieldValue);
  const prevSelectFieldValueRef = React.useRef("");
  prevSelectFieldValueRef.current = prevSelectFieldValue;

  const prevSelected = usePrevious(selected);
  const prevSelectedRef = React.useRef([]);
  prevSelectedRef.current = prevSelected;

  useEffect(() => {
    // clear form when change from/to exact select option
    if (prevSelectFieldValueRef.current !== undefined &&
          selectFieldValue !== prevSelectFieldValueRef.current &&
          (selectFieldValue === selectOptions.EXACT ||  prevSelectFieldValueRef.current === selectOptions.EXACT) &&
          !(prevSelectedRef.current !== undefined && prevSelectedRef.current !== selectedRef.current && selectedRef.current.length > 0)
    ) {
      // @ts-ignore
      typeaheadRef.current.clear();
      setQuery(null);
      setFieldValue(name, "");
    }
  }, [selectFieldValue])

  const parseAutocompleteResponse = (response: any, responseName: string) => {
    return response.data?.data?.[responseName]?.map((i:any) => {
            return {
              value: i.name?i.name:i,
              specieid: i?.specieid,
              principal: i?.principal
            }
          }
        ).filter((val: any) => {
          // @ts-ignore
          return !multiple || typeaheadRef.current?.state?.selected === "" || typeaheadRef.current?.state?.selected?.findIndex((item:any) => item.value === val.value) === -1
        });
  }
  useEffect(() => {
    if (query) {
      if (prevSelectFieldValue === selectFieldValue && selectFieldValue === selectOptions.EXACT) {
        setIsLoading(true);
        setOptions([]);
        axios.post(postUrl, postData(autoCompleteName, query, selectOptions.CONTAINS, includeSynonymsFieldValue, autoCompleteReturnString)).then( (response: any) => {
          const data = parseAutocompleteResponse(response, autoCompleteName);
          setOptions(data?data:[]);
          setQuery(null);
        }).catch(err => console.log(err))
        .finally(() => setIsLoading(false))
      } else {
        setOptions([]);
      }
    }
    // eslint-disable-next-line
  }, [query, autoCompleteName, selectFieldValue])

  const onBlurHandler = () => {
    // @ts-ignore
    const currentValue = typeaheadRef.current.inputNode.value;
    // @ts-ignore
    const currentSelected = [...typeaheadRef.current.state.selected];
    if (currentValue && !currentSelected.find((el: any) => (el.value === currentValue))) {
      if (props.allowNew) {
        // @ts-ignore
        typeaheadRef.current._handleSelectionAdd({customOption: true, value: currentValue});
      } else {
        // @ts-ignore
        typeaheadRef.current.clear();
        setQuery(null);
        setFieldValue(name, "");
      }
    }
    setOptions([]);
  }

  const _handleKeyDown = (e: any) => {
    if (e.keyCode === 13 || e.keyCode === 9) {
      onBlurHandler();
    }
  }

  React.useEffect(() => {
    window.addEventListener("keydown", _handleKeyDown);

    return () => {
      window.removeEventListener("keydown", _handleKeyDown);
    };
  }, [])

  return (
    <AsyncTypeahead
      {...props}
      selected={!Array.isArray(props.selected)?[]:props.selected}
      className={[classes.typeahead,props.className].join(" ")}
      isLoading={isLoading}
      labelKey="value"
      minLength={parseInt(process.env.REACT_APP_AUTOCOMPLETE_MIN_LENGTH!)}
      onSearch={setQuery}
      onChange={(val: any) => { setFieldValue(name, val); }}
      options={options}
      onBlur={onBlurHandler}
      onKeyDown={_handleKeyDown}
      ref={typeaheadRef}
      renderMenuItemChildren={(option: any, renderProps) => (
        <span style={{color: !includeSynonymsFieldValue || (includeSynonymsFieldValue && option.principal)?'inherit':'#00447a'}}>
          <EllipsisWithTooltip placement="bottom">
            <Highlighter search={renderProps.text}>
                {option.value}
              </Highlighter>
          </EllipsisWithTooltip>
        </span>
      )}
    />
  );
};

export default CustomAsyncTypehead;
